import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,_vm._g(_vm._b({class:['button', _vm.size, _vm.type],style:({
    backgroundColor: _vm.disabled ? '#ACABAB !important' : undefined,
    color: _vm.disabled ? '#fff !important' : undefined,
  }),attrs:{"disabled":_vm.disabled,"depressed":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }